import React from "react";
import { Row, Col, Badge } from "reactstrap";
import { FormattedDate } from "react-intl";
import { FormattedNumber, formattedNumber } from "../../FormattedNumber/FormattedNumber";
import PropTypes from "prop-types";

import { CustomFormInput } from "../../..";

const SettleInst = ({ settleInst }) => (
  <React.Fragment>
    <Row className="mb-3">
      <Col>
        <Badge className="Badge p-1 pl-2 pr-2" color={settleInst.SettleInstSide.toLowerCase()}>
          {" "}
          {settleInst.SettleInstSide.toUpperCase()}
        </Badge>
        {settleInst.Calculated.HasClientQuantity && (
          <Badge color="primary" className="ml-2">
            CL
          </Badge>
        )}
        {settleInst.Calculated.HasPropQuantity && (
          <Badge color="primary" className="ml-2">
            PP
          </Badge>
        )}
        {settleInst.Calculated.HasTradingQuantity && (
          <Badge color="primary" className="ml-2">
            TR
          </Badge>
        )}
        {settleInst.Calculated.HasErrorQuantity && (
          <Badge color="primary" className="ml-2">
            ER
          </Badge>
        )}{" "}
        <FormattedNumber value={settleInst.SettleInstQuantity} dataTypeDecimalName="quantity" />{" "}
        {settleInst.SettleInstAssetTicker}
      </Col>
    </Row>
    <Row>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Status">{settleInst.SettleInstStatus}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="ISIN">{settleInst.SettleInstAssetISIN}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Total">
          {formattedNumber(settleInst.SettleInstNetSettleValue, "currency")}{" "}
          {settleInst.SettleInstSettleCurrencyISO}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Custody">
          {settleInst.Calculated.HasClientQuantity || settleInst.Calculated.HasErrorQuantity
            ? settleInst.SettleInstOurClientCustName +
              (settleInst.Calculated.HasPropQuantity || settleInst.Calculated.HasTradingQuantity
                ? ` - ${settleInst.SettleInstOurPropCustName}`
                : "")
            : settleInst.SettleInstOurPropCustName}
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Counter Party">{settleInst.SettleInstCounterPartyName}</CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="TS">
          <FormattedDate value={`${settleInst.SettleInstValueDate}T00:00`} />
        </CustomFormInput>
      </Col>
      <Col xs={6} md={4} lg={3}>
        <CustomFormInput label="Type">{settleInst.SettleInstType}</CustomFormInput>
      </Col>
    </Row>
  </React.Fragment>
);

SettleInst.propTypes = {
  settleInst: PropTypes.object.isRequired,
};

export default SettleInst;
